import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from 'axios'

import utils from "@/utils";  // 1.先引入
Vue.prototype.$utils = utils;   // 2.直接定义在vue的原型上面

//配置公共方法
import common from './components/common/common.js'
Vue.prototype.$noMultipleClicks = common.noMultipleClicks;

Vue.config.productionTip = false
// 2019.10.31 之前写的下面三行代码，想要配置反向代理，但是不行。现在看来应该写在request文件夹下的http.js文件里，
// axios.defaults.baseURL = '/api'; 
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = axios

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
})


/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')

// 浏览器关闭事件
// window.addEventListener('beforeunload', () => {
// 	localStorage.removeItem('token')
// })